import { getConfiguration } from "modules/configuration"
import io from "socket.io-client"

const config = getConfiguration()

export const socket = io(config.API_WS_URL, {
  auth: { token: `auth token` },
  transports: ["websocket", "polling"],
})

/*
 * NOTE: While we only deal with dollars in price atm, let's keep the structure as object for flexibility.
 * Eg. new price feed also prices prices for ATH, ATL and whatnot.
 * Comment referring to plain "number" being returned by usePrice -hooks being far simpler to use
 */
export type PriceDataValue = { usd?: number; eur?: number }
export type PriceDataType = { [key: string]: PriceDataValue }

type MarketPriceDataValue = {
  latest?: number
  change24h?: number
  change7d?: number
  change30d?: number
  ath?: number
  atl?: number
}

export type MarketDataType = {
  [key: string]: {
    price?: MarketPriceDataValue
  }
}
